<template>
  <div class="side-button-container">
    <img @click="goTop" class="btn" src="../../assets/img/to-top.png"  />
    <!-- <button class="btn" @click="goTop">
      <img src="../../assets/img/to-top.png" width=""/>
    </button> -->
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
export default {
  data() {
    return {}
  },
  created() { },
  methods: {
    ...mapMutations(['updateIsArriveBottom', 'updateisShowAD']),
    goTop() {
      if (this.screenWidth > 540) {
        this.$emit('goTop')
        return
      }
      document.documentElement.scrollTop = 0
      this.updateisShowAD(false)
    }
  },
  computed: {
    ...mapState(['isArriveBottom', 'screenWidth'])
  }
}
</script>

<style lang="less" scoped>
.side-button-container {
  .btn {
    width: 3.5rem;
    height: 3.5rem;
    // box-shadow: rgb(190, 189, 189) 0px 0px 10px; //将h-shadow,v-shadow设为0px,实现四周阴影
    // background-color: #c2a552;
    cursor: pointer;
    border: none !important;

  }
}

</style>
<style>
img {
  vertical-align: middle;
}
</style>
